var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title d-flex justify-content-center"},[_c('div',{staticClass:"icon-rounded icon-rounded-primary"},[_vm._t("icon")],2)]),_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.value))]),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }